import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { closeWindow, getUserId, isInLiff } from '../lib/liff';
import BookingView, { type BookingDetail } from '../components/BookingView';
import LoadingSpinner from '../components/LoadingSpinner';
import { IconCheck } from '../components/Icons';
import { Screen, btnPrimary, btnSoft } from '../components/ui';

export default function SuccessPage() {
  const { bookingId } = useParams<{ bookingId: string }>();
  const [booking, setBooking] = useState<BookingDetail | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bookingId) return;
    const lineUserId = getUserId();
    api.getBooking(bookingId, lineUserId || undefined).then((response) => {
      if (response.success && response.data) setBooking(response.data);
      setLoading(false);
    });
  }, [bookingId]);

  if (loading) return <LoadingSpinner />;

  return (
    <Screen className="pb-10">
      <div className="safe-top flex flex-col items-center text-center gap-3 px-6 pt-14 pb-6">
        <span className="w-16 h-16 rounded-full bg-ok-dot text-white inline-flex items-center justify-center">
          <IconCheck size={32} strokeWidth={3} />
        </span>
        <h1 className="text-2xl font-black mt-1">報名送出了</h1>
        <p className="text-sm text-muted leading-relaxed max-w-xs">
          {booking?.paymentStatus === 'pending' ? '最後一步是匯款。匯款資訊也可以隨時在「我的報名」找到。' : '我們已收到你的資料。'}
        </p>
      </div>

      <div className="px-5">
        {booking ? (
          <BookingView booking={booking} />
        ) : (
          <p className="text-sm text-muted text-center">報名已送出，但暫時讀不到明細。可以稍後到「我的報名」查看。</p>
        )}
      </div>

      <div className="flex flex-col gap-2 px-5 mt-6">
        <Link to="/my-bookings" className={btnPrimary}>前往我的報名</Link>
        {isInLiff() ? (
          <button type="button" onClick={() => closeWindow()} className={btnSoft}>關閉視窗</button>
        ) : (
          <Link to="/" className={btnSoft}>回首頁</Link>
        )}
      </div>
    </Screen>
  );
}
